export interface AccountInfo {
  custId: number;
  countryCode: string;
  currency: string;
  timezone: string;
  accountDetails: AccountDetails;
}

export interface AccountDetails {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string;
  countryCode: string;
  address: Address;
}

export interface Address {
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  country: string;
  zip: string;
  zip2: string;
}

export interface InitState {
  accountInfo: AccountInfo;
  isUserInfoLoaded: boolean;
}

export const initialState: InitState = {
  accountInfo: null,
  isUserInfoLoaded: false,
};
